<style lang="postcss">
@reference "../../../app.css";

.active {
  @apply bg-base-3 hover:bg-none;
}
.link {
  @apply rounded-lg px-4 py-1.5 text-center text-sm leading-6 font-semibold transition;
  @apply hover:bg-base-3;
}
</style>

<script>
import { resolve } from "$app/paths";
import { page } from "$app/state";

import { cn, isActivePath } from "$lib/utils";

let { href, class: klass, children } = $props();

const _class = $derived(cn("link", "sm:min-w-max", "min-w-[85px]", klass));
</script>

{#if href}
  <a
    class={_class}
    class:active={isActivePath(page, href)}
    aria-current={isActivePath(page, href) ? "page" : undefined}
    href={resolve(href)}
  >
    {@render children?.()}
  </a>
{/if}
